module.exports = __webpack_public_path__ + "img/130.a5e57d7d.jpg";